module.exports = __webpack_public_path__ + "img/st.4c0fcea2.svg";